import secureLocalStorage from "react-secure-storage";
import React, { Component, PureComponent } from "react";
import { process } from "@progress/kendo-data-query";
import {
  Grid,
  GridColumn as Column,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import Api from "../../Services/Api";
import * as moment from "moment";
import TextNarrative from "./TextNarrative";
import { CircularProgress } from "@material-ui/core";
import { Popup } from "@progress/kendo-react-popup";
import "hammerjs";
import { Dropdown } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import AddToCart from "../Tenant/AddToCart";
import ColumnMenu from "../Dashboard/ColumnMenu";
import CurrencyFormat from "../Tenant/Component/CurrencyFormat";
import CheckBox from "../Tenant/CheckBox";
import MitigationNameCell from "../Tenant/Component/MitigationNameCell";
import SkeletonReport from "./SkeletonReport";
import TextNarrativeExport from "./TextNarrativeExport";
import ReportUpdate from "./ReportUpdate";
export default class DataReportForAction extends Component {
  gridPDFExport;
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      dataState: {
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
        take: 15,
        skip: 0,
      },
      loader: false,
      mitigationData: [],
      emailId: "",
      message: "",
      projectHomeFlag: false,
      openPdfTitlePopup: false,
      title: "",
      showAddToCart: false,
      visible: false,
      openPdfTitlePopup: false,
      isReportLoaded: false,
      chartData: {},
      tempchartdata: {},
    };
    this._exporterAction = React.createRef();
  }

  componentDidUpdate(prevProps) {}
  componentDidMount = () => {
    if (
      this.props.dashboardId &&
      this.props.reportId &&
      !this.props.chartInputs
    ) {
      this.fetchReportsByPagination(
        this.props.dashboardId,
        this.props.reportId
      );
    } else {
      this.setState({
        chartData: this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded: true,
      });
      this.init(this.props.chartInputs);
    }
  };
  fetchReportsByPagination = async (dashboardId, reportId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        WidgetListIds: [reportId],
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        this.setState({
          chartData: response.chartData[0],
          isReportLoaded: true,
        });
        this.init(response.chartData[0]);
        this.props.updateResponse(reportId, response.chartData[0]);
      } else {
        this.setState({
          chartData: {},
          isReportLoaded: true,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        chartData: {},
        isReportLoaded: true,
      });
    }
  };
  init = async (chartData) => {
    this.setState({ ...this.state, tempchartdata: chartData });
    if (
      chartData &&
      chartData.isActionWidget &&
      chartData.datasetResponseAction &&
      chartData.datasetResponseAction.result &&
      chartData.datasetResponseAction.result.riskMitigationResponse
    ) {
      let riskMitigationResponse =
        chartData.datasetResponseAction.result.riskMitigationResponse;
      riskMitigationResponse.map((riskReg) => {
        riskReg.createdDate = riskReg.createdDate
          ? new Date(riskReg.createdDate)
          : "";
        riskReg.actualCompletionDate = riskReg.actualCompletionDate
          ? new Date(riskReg.actualCompletionDate)
          : "";
        riskReg.projectedCompletionDate = riskReg.projectedCompletionDate
          ? new Date(riskReg.projectedCompletionDate)
          : "";
        riskReg.originalCompletionDate = riskReg.originalCompletionDate
          ? new Date(riskReg.originalCompletionDate)
          : "";
        riskReg.proximityDate = riskReg.proximityDate
          ? new Date(riskReg.proximityDate)
          : "";
        if (riskReg.closedDate) {
          riskReg.closedDate = new Date(riskReg.closedDate);
        } else {
          riskReg.closedDate = null;
        }
        if (riskReg.updatedDate) {
          var time = moment(riskReg.updatedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let updatedDate = time;
          riskReg.updatedDate = riskReg.updatedDate
            ? new Date(updatedDate)
            : "";
        } else {
          riskReg.updatedDate = null;
        }
        if (riskReg.createdDate) {
          var time = moment(riskReg.createdDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let createdDate = time;
          riskReg.createdDate = riskReg.createdDate
            ? new Date(createdDate)
            : "";
        } else {
          riskReg.createdDate = null;
        }
        if (riskReg.isOpen) {
          riskReg.isOpen = "Open";
        } else {
          riskReg.isOpen = "Close";
        }
        if (riskReg.approved) {
          riskReg.approved = "Yes";
        } else {
          riskReg.approved = "No";
        }
      });
      this.createDynamicCols(riskMitigationResponse);
    }
  };

  mitigationFilterQuery() {}

  createDynamicCols = async (products) => {
    try {
      let impactMaster = [];
      if (products && products.length > 0) {
        impactMaster = products[0].impactResponse;
      }

      let impactColumn = [];

      products.map((res, i) => {
        if (res.impactResponse) {
          res.impactResponse.map((item, j) => {
            if (impactColumn.length > 0) {
              if (!impactColumn.includes(item.name)) {
                impactColumn.push(item.name);
              }
            } else {
              impactColumn.push(item.name);
            }
          });
        }
      });

      if (impactColumn.length > 0) {
        products.map((res) => {
          impactColumn.map((col) => {
            let temp = res.impactResponse.find((item) => item.name === col);
            if (temp) {
              res[col] =
                temp.impactType == "Quantitative" ? temp.value : temp.qValue;
            } else {
              res[col] = undefined;
            }
          });
        });
      }
      let columnsToShow = [];
      if (impactColumn.length > 0) {
        columnsToShow = impactColumn.map((item) => (
          <Column
            field={item}
            title={"Change in " + this.getImpactUnit(item, impactMaster)}
            width="100px"
            editable={false}
            filter={"numeric"}
            columnMenu={ColumnMenu}
            cell={(props) => (
              <CurrencyFormat {...props} onEditCell={this.onEditCell} />
            )}
          />
        ));
      }
      this.setState({
        ...this.state,
        impactColumns: columnsToShow,
        mitigationData: products,
        mitigationDataTemp: products,
        chartData: this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded: true,
      });
    } catch (err) {
      console.log(err);
    }
  };
  getImpactUnit = (impact, impactMaster) => {
    var res = impact;
    var impactTemp = impactMaster.find((item) => item.name == impact);

    if (impactTemp && impactTemp.name) {
      res = impactTemp.name + " / " + impactTemp.units;
    }
    return res;
  };
  changeLineChartWidth = (widgetId) => {
    this.props.changeLineChartWidth(widgetId);
  };
  selectedDB = (data) => {
    this.props.selectedDB(data);
  };

  openAddToCart(data) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: "Mitigation",
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }

  shareFile = (widgetId) => {
    this._exporterAction.current.toDataURL().then((dataURL) => {
      this.sendMail(dataURL, widgetId);
    });
  };

  sendMail = async (dataURL, widgetId) => {
    let widgetName = this.state.tempchartdata
      ? this.state.tempchartdata.widgetName
      : "Bar-chart";
    const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");

    var file = this.dataURLtoFile(dataURL, widgetName + ".xlsx");
    var fd = new FormData(document.forms[0]);
    fd.append("file", file);
    fd.append("mailId", this.state.emailId);
    fd.append("message", this.state.message);
    fd.append("widgetId", widgetId);
    fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
    fd.append("CreatedDate", CreatedDate);
    fd.append("name", secureLocalStorage.getItem("userName"));
    fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
    this.setState({ ...this.state, loader: true });
    let response = await Api.shareWidgetToUser(fd);
    if (response.status === 200) {
      this.setState({ ...this.state, loader: false, emailId: "", message: "" });
      toastr.success(response.message);
    } else {
      this.setState({ ...this.state, loader: false });
      toastr.error(response.message);
    }
  };

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  onExportExcelClick = () => {
    this._exporterAction.current.save();
  };

  pdfTitlePopupClose = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        openPdfTitlePopup: false,
        title: "",
        isHidden: false,
      });
    }, 1000);
  };
  pdfTitlePopupOpen = () => {
    this.setState({
      ...this.state,
      openPdfTitlePopup: true,
      isHidden: true,
    });
  };
  onPDFExportClick = () => {
    if (this.gridPDFExport) {
      this.gridPDFExport.save();
    }
    this.pdfTitlePopupClose();
  };

  openWidgetDeletePopup = () => {
    if (!this.props.isFreezeDS) {
      this.setState({
        ...this.state,
        openDeleteModelFlag: true,
      });
    }
  };
  closeWidgetDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
    });
  };

  removeWidget = async (data) => {
    try {
      const requestParams = {
        DeletedBy: data.widgetId||this.props.reportId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteWidget(requestParams);
      if (response.status === 200) {
        toastr.success(response.message);
        this.closeWidgetDeletePopup();
        this.props.selectedDB(true);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  moveToHome = async (data) => {
    try {
      var req = {
        Enable: true,
        WidgetId: data.widgetId,
        CreatedBY: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  onEditCell() {}
  refreshTextNarative = (text, widgetId) => {
    this.props.refreshTextNarative &&
      this.props.refreshTextNarative(text, widgetId);
  };
   editWidgetOpen = (data) => {
    this.refs.childUpdateWidget.editWidgetdOpen(data);
  };
  updateChartData = async (data) => {
    await this.fetchReportsByPagination(data.dashboardId, data.widgetId);
    this.refs.childUpdateWidget.updateReportPopupClose();
  };
  render() {
    const chartData = this.state.tempchartdata ? this.state.tempchartdata : {};
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const CreatedDate = moment(chartData.createdDate).format("DD-MMM-yyyy");
    if (!this.state.isReportLoaded) {
      return <SkeletonReport />;
    } else {
      return (
        <div id="capture">
          {this.props.expandIcon && (
            <div className="expandView">
              <a
                className="expand"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.VIEWFULLVIEW} alt="Expand" width="10" />
              </a>
              <a
                className="shrink"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.SHRINK} alt="Expand" width="10" />
              </a>
            </div>
          )}
          {this.props.flag ? (
            <ul className="WidgetActions">
              {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                    <li onClick={() => this.editWidgetOpen(chartData)}>
                      <a>
                        <img src={Images.EDITICON} alt="Edit" width="14" />
                      </a>
                    </li>
                  )
                : ""}
              <TextNarrative
                chartInputs={chartData}
                refreshTextNarative={this.refreshTextNarative}
                isFreezeDS={this.props.isFreezeDS}
              />
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li
                  title="Add to home"
                  onClick={() => this.moveToHome(chartData)}
                >
                  <a>
                    <img src={Images.HOME} alt="Download" width="14" />
                  </a>
                </li>
              )}

              <li onClick={this.onExportExcelClick}>
                <a>
                  <img src={Images.XLSX} alt="Download" width="14" />
                </a>
              </li>
              {/* <li onClick={this.pdfTitlePopupOpen}>
              <a>
                <img src={Images.PDF} alt="Download" width="14" />
              </a>
            </li> */}
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li onClick={() => this.openAddToCart(chartData.dataSourceId)}>
                  <a>
                    <img src={Images.SHARE} alt="Download" width="14" />
                  </a>
                </li>
              )}
              <li>
                <Dropdown
                  menuAlign="right"
                  title="Mail"
                  id="dropdown-menu-align-right"
                >
                  <Dropdown.Toggle>
                    <a>
                      <img src={Images.EMAIL} alt="Share" width="14" />
                    </a>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="filterList emailBox">
                    <div className="filterBox">
                      <div className="dateRange">
                        <div className="dateCont">
                          <h6>Email</h6>
                          <input
                            type="email"
                            autoComplete="off"
                            value={this.state.emailId}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                emailId: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="dateCont">
                          <h6>Message</h6>
                          <textarea
                            value={this.state.message}
                            autoComplete="off"
                            onChange={(e) =>
                              this.setState({
                                message: e.target.value,
                              })
                            }
                          ></textarea>
                          <Dropdown.Item
                            as="button"
                            onClick={() => this.shareFile(chartData.widgetId)}
                          >
                            SEND
                          </Dropdown.Item>
                        </div>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </li>

              {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                    <li onClick={this.openWidgetDeletePopup}>
                      <a className="bgRed">
                        <img src={Images.TRASH} alt="Trash" width="13" />
                      </a>
                    </li>
                  )
                : ""}
            </ul>
          ) : (
            <ul className="WidgetActions">
              {/* <li
              title="Remove from home"
              onClick={() => this.removeFromHome(chartData)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li> */}
            </ul>
          )}

          <div
            id={"c" + chartData.widgetId}
            className="tblCont riskRegister dataGrids reportsGrid"
            key={chartData.title}
          >
            <div className="titleBG">
              <span>{chartData.title}</span>
              {/* <small className="createdDate">{CreatedDate}</small> */}
            </div>
            <ExcelExport
              data={this.state.mitigationData}
              fileName={
                chartData.widgetName
                  ? chartData.widgetName.replace(".", " ")
                  : "Action" + ".xlsx"
              }
              ref={this._exporterAction}
              headerPaddingCellOptions={{
                background: "#ff0000",
              }}
            >
              <Grid
                style={{ minHeight: "100px" }}
                data={process(this.state.mitigationData, this.state.dataState)}
                {...this.state.dataState}
                reorderable
                resizable
                sortable={true}
                pageable={true}
                onDataStateChange={(e) => {
                  this.setState({ dataState: e.dataState });
                }}
              >
                <GridNoRecords>
                  {chartData.notValidPrimeDataset
                    ? "Cannot load dataset as Prime settings have been changed for Tenant or Workstream"
                    : chartData.isCustomFieldDeleted
                    ? "Associated Dataset's Custom fields might been deleted or revoked"
                    : chartData.isImpactDeleted
                    ? "Associated Dataset's Impact fields might been deleted or revoked"
                    : chartData.isTaskModuleDisabled
                    ? "Cannot load report as Task Module settings have been changed for Tenant. Please contact administrator."
                    : "No records available"}
                </GridNoRecords>

                <Column
                  field="organisationName"
                  title="Workstream"
                  width="200px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="riskNumber"
                  title="Risk Number"
                  width="200px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="riskName"
                  title="Risk"
                  width="200px"
                  // columnMenu={ColumnMenu}
                  cell={(props) => (
                    <MitigationNameCell
                      {...props}
                      onEditCell={this.onEditCell}
                    />
                  )}
                />
                <Column
                  field="isOpportunity"
                  title="T/O"
                  width="100px"
                  cell={(props) =>
                    props.dataItem.isOpportunity === "Threat" ? (
                      <td>{props.dataItem.isOpportunity}</td>
                    ) : (
                      <td>
                        <span className="turquoiseBlue">
                          {props.dataItem.isOpportunity}
                        </span>
                      </td>
                    )
                  }
                />
                <Column
                  field="name"
                  title="Action Title"
                  width="200px"
                  // columnMenu={ColumnMenu}
                  cell={(props) => (
                    <MitigationNameCell
                      {...props}
                      onEditCell={this.onEditCell}
                    />
                  )}
                />
                <Column
                  field="number"
                  title="Action Number"
                  width="120px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="approved"
                  title="Approved"
                  cell={(props) => (
                    <CheckBox {...props} onEditCell={this.onEditCell} />
                  )}
                  filter={"boolean"}
                  width="100px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="control"
                  title="Description"
                  width="120px"
                  cell={(props) => (
                    <MitigationNameCell
                      {...props}
                      onEditCell={this.onEditCell}
                    />
                  )}
                />
                <Column
                  field="externalReference"
                  title="External Reference"
                  width="120px"
                  cell={(props) => (
                    <MitigationNameCell
                      {...props}
                      onEditCell={this.onEditCell}
                    />
                  )}
                />
                <Column field="actionType" title="Action Type" width="120px" />
                <Column field="riskTypeNames" title="Risk Type" width="150px" />
                <Column
                  field="cost"
                  title={"Cost of Action / " + secureLocalStorage.getItem("currency")}
                  width="80px"
                  // columnMenu={ColumnMenu}
                  cell={(props) => (
                    <CurrencyFormat {...props} onEditCell={this.onEditCell} />
                  )}
                />
                <Column
                  field="reductionFrequency"
                  width="80px"
                  title="Change in Probability (%)"
                  // columnMenu={ColumnMenu}
                  cell={(props) => (
                    <CurrencyFormat {...props} onEditCell={this.onEditCell} />
                  )}
                />
                {this.state.impactColumns}
                <Column
                  field="spi"
                  title="% On Track"
                  width="80px"
                  filter={"number"}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="percentageCompletion"
                  title="% Completion"
                  width="100px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="originalCompletionDate"
                  width="100px"
                  title="Original Completion Date"
                  filter={"date"}
                  format="{0:dd-MMM-yyyy}"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="projectedCompletionDate"
                  width="100px"
                  title="Projected Completion Date"
                  filter={"date"}
                  format="{0:dd-MMM-yyyy}"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="actualCompletionDate"
                  width="100px"
                  title="Actual Completion Date"
                  filter={"date"}
                  format="{0:dd-MMM-yyyy}"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="proximityDate"
                  title="Proximity Alert Date"
                  width="100px"
                  filter={"date"}
                  format="{0:dd-MMM-yyyy}"
                />
                <Column
                  field="daysOverdue"
                  title="Original Days Overdue"
                  width="120px"
                />
                <Column
                  field="projectedOverdueActionCount"
                  title="Projected Days Overdue"
                  width="120px"
                />

                <Column
                  field="owner"
                  title="Owner"
                  width="100px"
                  // columnMenu={ColumnMenu}
                />

                <Column
                  field="actionFieldsCompletion"
                  title="% of fields completed"
                  width="120px"
                  editable={false}
                />
                <Column
                  field="createdDate"
                  width="100px"
                  title="Created Date"
                  filter={"date"}
                  // columnMenu={ColumnMenu}
                  format="{0:dd-MMM-yyyy}"
                />
                <Column
                  field="createdByName"
                  width="100px"
                  title="Created By"
                />
                <Column
                  field="updatedDate"
                  title="updated Date"
                  width="120px"
                  editor="date"
                  filter={"date"}
                  editable={false}
                  format="{0:dd-MMM-yyyy}"
                />
                <Column field="updatedBy" title="updated By" width="120px" />
                <Column field="isOpen" title="Status" width="80px" />
                <Column
                  field="closedDate"
                  title="closed Date"
                  width="120px"
                  format="{0:dd-MMM-yyyy}"
                />
                <Column field="departments" title="Departments" width="150px" />
                <Column
                  field="externalStatus"
                  title="External Status"
                  width="120px"
                />
                <Column
                  field="weeklyReport"
                  title="Weekly Report"
                  width="100px"
                />
              </Grid>
            </ExcelExport>
            <GridPDFExport
              ref={(pdfExport) => (this.gridPDFExport = pdfExport)}
              fileName={chartData.widgetName ? chartData.widgetName : "Action"}
              margin="1cm"
              date={new Date()}
              // paperSize={["1000mm", "400mm"]}
              paperSize={"auto"}
              title={this.state.title + " " + CreatedDate}
              repeatHeaders={true}
            >
              <Grid
                style={{ minHeight: "100px" }}
                data={process(this.state.mitigationData, this.state.dataState)}
                {...this.state.dataState}
                reorderable
                resizable
                sortable={true}
                pageable={true}
                onDataStateChange={(e) => {
                  this.setState({ dataState: e.dataState });
                }}
              >
                <GridNoRecords>
                  {chartData.notValidPrimeDataset
                    ? "Cannot load dataset as Prime settings have been changed for Tenant or Workstream"
                    : chartData.isCustomFieldDeleted
                    ? "Associated Dataset's Custom fields might been deleted or revoked"
                    : chartData.isImpactDeleted
                    ? "Associated Dataset's Impact fields might been deleted or revoked"
                    : chartData.isTaskModuleDisabled
                    ? "Cannot load report as Task Module settings have been changed for Tenant. Please contact administrator."
                    : "No records available"}
                </GridNoRecords>

                <Column
                  field="organisationName"
                  title="Workstream"
                  width="200px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="riskName"
                  title="Risk"
                  width="200px"
                  // columnMenu={ColumnMenu}
                  cell={(props) => (
                    <MitigationNameCell
                      {...props}
                      onEditCell={this.onEditCell}
                    />
                  )}
                />
                <Column
                  field="riskNumber"
                  title="Risk Number"
                  width="200px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="name"
                  title="Action Title"
                  width="200px"
                  // columnMenu={ColumnMenu}
                  cell={(props) => (
                    <MitigationNameCell
                      {...props}
                      onEditCell={this.onEditCell}
                    />
                  )}
                />
                <Column
                  field="number"
                  title="Action Number"
                  width="120px"
                  // columnMenu={ColumnMenu}
                />
                {/* <Column field="subMitigationCount" width="80px"  title="Sub-Mitigation Count" filter={ 'number' } columnMenu={ ColumnMenu }/> */}
                <Column
                  field="cost"
                  title={"Cost of Action / " + secureLocalStorage.getItem("currency")}
                  width="80px"
                  // columnMenu={ColumnMenu}
                  cell={(props) => (
                    <CurrencyFormat {...props} onEditCell={this.onEditCell} />
                  )}
                />
                <Column
                  field="reductionFrequency"
                  width="80px"
                  title="Reduction in Probability (%)"
                  // columnMenu={ColumnMenu}
                  cell={(props) => (
                    <CurrencyFormat {...props} onEditCell={this.onEditCell} />
                  )}
                />
                {this.state.impactColumns}
                <Column
                  field="spi"
                  title="% On Track"
                  width="80px"
                  filter={"number"}
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="percentageCompletion"
                  title="% Completion"
                  width="100px"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="originalCompletionDate"
                  width="100px"
                  title="Original Completion Date"
                  filter={"date"}
                  format="{0:dd-MMM-yyyy}"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="projectedCompletionDate"
                  width="100px"
                  title="Projected Completion Date"
                  filter={"date"}
                  format="{0:dd-MMM-yyyy}"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="actualCompletionDate"
                  width="100px"
                  title="Actual Completion Date"
                  filter={"date"}
                  format="{0:dd-MMM-yyyy}"
                  // columnMenu={ColumnMenu}
                />
                <Column
                  field="createdDate"
                  width="100px"
                  title="Created Date"
                  filter={"date"}
                  // columnMenu={ColumnMenu}
                  format="{0:dd-MMM-yyyy}"
                />

                <Column
                  field="owner"
                  title="Owner"
                  width="100px"
                  // columnMenu={ColumnMenu}
                />

                <Column
                  field="approved"
                  title="Approved"
                  cell={(props) => (
                    <CheckBox {...props} onEditCell={this.onEditCell} />
                  )}
                  filter={"boolean"}
                  width="100px"
                  // columnMenu={ColumnMenu}
                />

                <Column field="departments" title="Departments" width="150px" />
                <Column
                  field="externalStatus"
                  title="External Status"
                  width="120px"
                />
                <Column
                  field="weeklyReport"
                  title="Weekly Report"
                  width="100px"
                />
              </Grid>
            </GridPDFExport>
            <div className="wgHeader">
              <h4>Dataset: {chartData.dataSource} </h4>
            </div>
            <TextNarrativeExport
              chartData={chartData}
              isHidden={this.state.isHidden}
            />
          </div>
          <ReportUpdate
            chartData={chartData}
            ref="childUpdateWidget"
            updateChartData={this.updateChartData}
          />
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>

          <Popup
            show={this.state.openPdfTitlePopup}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}

            <div className="addTypeForm">
              <div className="fieldCont">
                <label>Enter Title</label>
                <input
                  type="text"
                  onChange={(e) => this.setState({ title: e.target.value })}
                  placeholder="Title"
                  value={this.state.title}
                  required
                />
              </div>
              <div className="btnGroup">
                <button
                  disabled={!this.state.title}
                  className="btnPrimary"
                  onClick={this.onPDFExportClick}
                >
                  Export
                </button>
                <button className="btnDark" onClick={this.pdfTitlePopupClose}>
                  Cancel
                </button>
              </div>
            </div>
          </Popup>

          <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
            <AddToCart
              {...this.props}
              closeAddToCart={() => this.closeAddToCart()}
              cartViewDetailsId={this.state.cartViewDetails}
              cartViewType={this.state.cartViewType}
            />
          </Popup>
        </div>
      );
    }
  }
}
